module.exports = __webpack_public_path__ + "media/images/empty-review-d5623ecebc5001d27e29a2a488941886.png";